import { defineComponent as _defineComponent } from 'vue'
import ReviewIconStar from './ReviewIconStar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewStars',
  props: {
  rating: {
    type: Number,
    default: 0
  }
},
  emits: ['handleRating'],
  setup(__props, { emit }) {

const props = __props





const handleRating = (star: number) => {
  emit('handleRating', star)
}

return { __sfc: true,props, emit, handleRating, ReviewIconStar }
}

})